import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import InsuranceProxy from './InsuranceProxy'

class InsuranceService extends ServiceBase {
  postLiquidityAndSolvencyAndCoverAge(params) {
    return this.getData(() =>
      InsuranceProxy.postLiquidityAndSolvencyAndCoverAge(params),
    )
  }
  downloadLiquidityAndSolvencyAndCoverAge(params) {
    return this.getFileDownload(() =>
      InsuranceProxy.downloadLiquiditySolvencyCoverage(params),
    )
  }
  postProfitability(params) {
    return this.getData(() => InsuranceProxy.postProfitability(params))
  }
  downloadProfitability(params) {
    return this.getFileDownload(() =>
      InsuranceProxy.downloadProfitability(params),
    )
  }
  postBusinessGrowth(params) {
    return this.getData(() => InsuranceProxy.postBusinessGrowth(params))
  }
  downloadBusinessGrowth(params) {
    return this.getFileDownload(() =>
      InsuranceProxy.downloadBusinessGrowth(params),
    )
  }
}

export default new InsuranceService()
